import React, { useRef } from "react"
import { graphql } from "gatsby"
// import * as styles from "./Embed.css"
import IframeResizer from 'iframe-resizer-react'
export type EmbedProps = {
  id: string
  url?: string
}


export default function Embed(props: EmbedProps) {

  const iframeRef = useRef(null)
  const id = props.id.replace("DatoCmsEmbed-","")
  const src = props.url || `/embeds/${id}.html`

  return (
    <IframeResizer
      forwardRef={iframeRef}
      heightCalculationMethod="lowestElement"
      log
      src={src}
      style={{ border: 0, width: '1px', minWidth: '100%'}}
    />
  )
}

export const query = graphql`
  fragment EmbedContent on Embed {
    desktopRight
    url
  }
`